export const messages = {
  en: {
    resourceSupplier: {
      title: 'Supplier Management',
      queryCondition: 'Query Conditions',
      supplierInfo: 'Supplier Information',
      supplierName: 'Supplier Name',
      contact: 'Contact',
      supplierId: 'Supplier ID',
      supplierAddress: 'Supplier Address',
      contactName: 'Contact Name',
      bank: 'Bank',
      bankAccount: 'Bank Account',
      remark: 'Remark',
      operation: 'Operation',
      addSupplier: 'Add Supplier',
      editSupplier: 'Edit Supplier',
      deleteConfirm: 'Are you sure to delete this supplier?',
      query: 'Query',
      reset: 'Reset',
      back: 'Back',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      required: 'This field is required',
      maxLength: 'Input exceeds maximum length',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      deleteSuccess: 'Delete successfully'
    }
  },
  zh: {
    resourceSupplier: {
      title: '供应商管理',
      queryCondition: '查询条件',
      supplierInfo: '供应商信息',
      supplierName: '供应商名称',
      contact: '联系方式',
      supplierId: '供应商编号',
      supplierAddress: '供应商地址',
      contactName: '联系人姓名',
      bank: '开户行',
      bankAccount: '开户行账号',
      remark: '备注',
      operation: '操作',
      addSupplier: '添加供应商',
      editSupplier: '修改供应商',
      deleteConfirm: '确定删除该供应商吗？',
      query: '查询',
      reset: '重置',
      back: '返回',
      cancel: '取消',
      save: '保存',
      delete: '删除',
      required: '该字段不能为空',
      maxLength: '输入超过最大长度限制',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功'
    }
  }
}